import React from 'react';

type FormatPriceProps = {
  priceToFormat: number;
};

const FormatPrice = ({ priceToFormat }: FormatPriceProps) => {
  const dollars = Math.floor(priceToFormat);
  let cents: number | string = Math.round((priceToFormat - dollars) * 100);

  if (cents === 0) {
    return <>{dollars}</>;
  }
  if (cents === 100) {
    return <>{dollars + 1}</>;
  }

  if (cents < 10) {
    cents = `0${cents}`;
  }
  return (
    <>
      {dollars}
      <span className="util-hide">.</span>
      <span className="cents">{cents}</span>
    </>
  );
};

export default FormatPrice;
